import React from "react";
import ContactForm from "./ContactForm";
import Socials from "./Socials";
// import Completion from "../misc/Completion";

const Connect = () => {
    return (
        <>
            {/* <Completion percentage="99" status="Making more beautiful" /> */}
            <div className="my-20">
                <Socials />
            </div>
            <div className="my-20">
                <ContactForm />
            </div>
        </>
    );
};

export default Connect;
